import { useEffect, useRef } from "react";
import { Modal } from "cai-fusion";

import { useTransientVisibility } from "../../../../fusion/Contexts/VisualContext";
import { useSiftV2 } from "../../../contexts/siftV2Context";
import SymphonyFileHandler from "../../../../symphony/components/symphonyFileHandler";
import env from "../../../../../configs/envConfig";

const OpportunityAddFileModal = () => {

    const { hide, visibilityStates } = useTransientVisibility();
    const { curOpp } = useSiftV2();
    const uploaderRef = useRef(null);

    return (
        <Modal
            title="Upload Files"
            isHidden={ !visibilityStates.OpportunityAddFileModal }
            onClose={() => hide('OpportunityAddFileModal')}
            id="uploadModal"
            clickOutsideToClose
        >
            <div ref={uploaderRef} className="l-row">
                <div className="l-one-col">
                    <p>
                        To allow {env.REACT_APP_BRANDING_SYMPHONY_NAME ?? "Maestro"} to better answer your questions, you may upload
                        files such as documents or spreadsheets. Your files will be used to further analyze this opportunity.
                    </p>
                    <p className="a-muted-text">Supported files include .xlsx, .docx, .pdf, .csv, and .ppt.</p>

                    <SymphonyFileHandler 
                        files={curOpp?.request?.requestFiles?.map((file) => ({"resourceName": file.fileName}))}
                        uploadRef={uploaderRef}
                    />
                </div>
            </div>
        </Modal>
    );
}

export default OpportunityAddFileModal;
